import styles from './footer.module.scss';
import ShButton from "../../../components/button/shButton";
import Emoji from "react-emoji-render";

import BrandIconWordMark from 'public/logo/brand-wordmark-slogan-negativ.svg';

import FacebookSVG from 'public/icons/facebook.svg';
import InstagramSVG from 'public/icons/instagram.svg';
import YoutubeSVG from 'public/icons/youtube.svg';
import PinterestSVG from 'public/icons/pinterest.svg';
import TiktokSVG from 'public/icons/tiktok.svg';

import Link from "next/link";
import { AuthContext } from "../../../provider/authProvider";
import { useContext, useState } from "react";
import ShAboPrice from "../../pricing/shAboPrice";
import { trackEvent } from "../../../helper/tracking/tracking";

import Cookies from 'js-cookie';
import ShAboPriceInstead from "../../pricing/shAboPriceInstead";

const Footer = () => {

    const authContext = useContext(AuthContext);

    const accepted = Cookies.get('cookie-consent') === 'accepted';
    const [ cookieVisible, setCookieVisible ] = useState(!accepted);

    const acceptCookies = () => {
        Cookies.set('cookie-consent', 'accepted');
        setCookieVisible(false);
    }

    return <>
        <footer className={styles.footer}>
            <div className="container mb-4">

                { (!authContext.isLoggedIn || (authContext.currentUserOverview?.current?.abo === false)) &&
                <div
                    className={styles.pass + ' d-flex flex-column flex-lg-row p-4 p-lg-5 align-items-left justify-content-between'}>
                    <div className="d-flex flex-column">
                        <h4>Hol dir den 7hauben Pass</h4>
                        <p className="text-white">Zugang zu allen Kursen nur <ShAboPrice/>  <ShAboPriceInstead /> </p>
                    </div>

                    <ShButton variant={'dark'} className="text-right mt-3 m-lg-0 mb-0" onClick={() => {
                        authContext.handlePassBuy();
                        trackEvent('startNowAction', {section: 'footer'});
                    }}>
                        <Emoji text="👨‍🍳 Jetzt loslegen"/>
                    </ShButton>
                </div>
                }
            </div>
            <div className={'container'}>
                <div className="row text-white px-0 px-xl-6 pl-4">
                    <div className="col-12 col-lg-2 mt-5">

                        <div className={styles.brandicon}>
                            <BrandIconWordMark />
                            <div className="w-100 mt-4 d-flex align-items-center justify-content-between">
                                <a href={"https://www.facebook.com/7Hauben/"} target={"_blank"}>
                                    <FacebookSVG className={"svg-24 svg-lobster"} />
                                </a>
                                <a href={"https://www.instagram.com/7hauben/"} target={"_blank"}>
                                    <InstagramSVG className={"svg-24 svg-lobster"} />
                                </a>
                                <a href={"https://www.youtube.com/c/7Hauben"} target={"_blank"}>
                                    <YoutubeSVG className={"svg-24 svg-lobster"} />
                                </a>
                                <a href={"https://www.pinterest.at/7hauben/"} target={"_blank"}>
                                    <PinterestSVG className={"svg-24 svg-lobster"} />
                                </a>
                                <a href={"https://www.tiktok.com/@7hauben"} target={"_blank"}>
                                    <TiktokSVG className={"svg-24 svg-lobster"} />
                                </a>
                            </div>

                            {authContext.currentUserOverview.current?.boughtCoursesId?.length > 0 &&
                            <a href={"https://www.facebook.com/groups/7hauben/"} target={"_blank"} className="d-block text-center mt-2 text-underline small-text">
                                zur Facebook-Gruppe
                            </a>
                            }
                        </div>
                    </div>

                    <div className="col-lg-2 col-6 mt-5">
                        <p className="opacity-50">Mein 7hauben</p>
                        <ul className={styles.nav}>
                        { !authContext.isLoggedIn && <>
                        <li className={"c-pointer"}  onClick={() => authContext.handleLogin(true)}>
                                <a>Login</a>
                        </li>
                        <li>
                            <Link href="/newsletter">
                                Newsletter
                            </Link>
                        </li>
                        <li>
                            <Link href="/affiliate">
                                Affiliate Programm
                            </Link>
                        </li>
                        <li className={"c-pointer"}>
                            <Link href="/faq">
                                Fragen & Antworten
                            </Link>
                        </li>
                        </>
                        }

                        { authContext.isLoggedIn && <>
                            <li className={"c-pointer"}>
                                <Link href="/profil/kurse">
                                    Meine Kurse
                                </Link>
                            </li>

                            <li className={"c-pointer"}>
                                <Link href="/profil/rezepte">
                                    Meine Rezepte
                                </Link>
                            </li>

                            <li className={"c-pointer"}>
                                <Link href="/profil/gutscheine">
                                    Meine Gutscheine
                                </Link>
                            </li>

                            <li className={"c-pointer"}>
                                <Link href="/profil/mein-account">
                                    Mein Account
                                </Link>
                            </li>

                            {/*<li className={isInternal ? "d-none" : "c-pointer"}>
                                <Link href="/profil/rechnungen">
                                    <a>Rechnungen</a>
                                </Link>
                            </li>*/}

                            <li className={"c-pointer"}>
                                <Link href="/profil/vorteile">
                                    Meine Vorteile
                                </Link>
                            </li>


                            <li className={"c-pointer"}
                                onClick={ () => authContext.logout() }
                            >
                                <a>Logout</a>
                            </li>
                        </>
                        }
                        </ul>

                        {/*<ShButton variant="outline" size="small" className={styles.minWidth + ' mt-3'}*/}
                        {/*          onClick={ () => { cogoToast.info("Noch nicht umgesetzt ;-)"); } }>*/}
                        {/*    Newsletter*/}
                        {/*</ShButton>*/}

                    </div>

                    <div className="col-lg-2 col-6 mt-5">

                        <p className="opacity-50">Kulinarik</p>

                        <ul className={styles.nav}>
                            <li>
                                <Link href="/kochkurse">
                                    Kochkurse
                                </Link>
                            </li>

                            <li>
                                <Link href="/gutscheine">
                                    Gutscheine
                                </Link>
                            </li>
                            <li>
                                <Link href="/experten">
                                    Experten
                                </Link>
                            </li>
                            <li>
                                <Link href="/rezepte">
                                    Rezepte
                                </Link>
                            </li>

                            <li>
                                <Link href="/blog">
                                    Blog
                                </Link>
                            </li>

                            <li>
                                <Link href="/lp/app">
                                    App
                                </Link>
                            </li>

                            {/*<li>
                                <Link href="/lp/geschenkbox">
                                    <a>Geschenk&shy;box</a>
                                </Link>
                            </li>*/}
                        </ul>


                    </div>
                    <div className="col-lg-2 col-6 mt-5">
                        <p className="opacity-50">Über 7hauben</p>

                        <ul className={styles.nav}>

                            <li className={"c-pointer"}>
                                <Link href="/kontakt">
                                    Kontakt
                                </Link>
                            </li>
                            <li className={"c-pointer"}>
                                <Link href="/team">
                                    Team
                                </Link>
                            </li>
                            <li className={"c-pointer"}>
                                <Link href="/jobs">
                                    Jobs
                                </Link>
                            </li>

                            <li className={"c-pointer"}>
                                <Link href="/presse">
                                    Presse
                                </Link>
                            </li>

                            <li className={"c-pointer"}>
                                <Link href="/kooperationen">
                                    Partner
                                </Link>
                            </li>

                            {authContext.isLoggedIn && <li>
                                <Link href="/affiliate">
                                    Affiliate Programm
                                </Link>
                            </li>
                            }

                            <li className={"c-pointer"}>
                                <Link href="/gastro">
                                    Gastro
                                </Link>
                            </li>

                            <li className={"c-pointer"}>
                                <Link href={"/studio"}>
                                    Studio
                                </Link>
                            </li>

                        </ul>
                    </div>

                    <div className="col-lg-2 col-6 mt-5">
                        <p className="opacity-50">Kleingedrucktes</p>
                        <ul className={styles.nav}>
                            <li className={"c-pointer"}>
                                <Link href="/inhalt/impressum">
                                    Impressum
                                </Link>
                            </li>
                            <li className={"c-pointer"}>
                                <Link href="/inhalt/allgemeine-geschaeftsbedingungen">
                                    AGB
                                </Link>
                            </li>
                            <li className={"c-pointer"}>
                                <Link href="/inhalt/datenschutz">
                                    Datenschutz
                                </Link>
                            </li>
                        </ul>
                    </div>
                </div>
                <div className={"row mt-5 d-flex align-items-center justify-content-center my-3 mr-0 mr-lg-6 " + styles.logos}>
                    <p className="text-white small-text mr-4 mr-lg-5 opacity-50 my-3"> gefördert durch</p>
                        <img src="/tmp/footer-bmdw.jpg" className="mr-4 mr-lg-5 my-3" />
                        <img src="/tmp/footer-aws.jpg" className="mr-4 mr-lg-5 my-3" />
                        <img src="/tmp/footer-tech2b.jpg" className="mr-0 mr-lg-5 my-3"/>
                </div>
                <div className="row">

                <div className="col-12">
                    <div className="mt-4 text-center">
                        <p className="opacity-50 text-white">&copy; 2023 - 7hauben</p>
                    </div>
                </div>
                </div>
            </div>
        </footer>


        {cookieVisible &&
        <div className="bg-solid-cream-02 p-3">
            <div className="container">
                <div className="row">
                    <div className="col-12">
                        <div className="flex flex-column align-items-center">
                            <p className={"d-inline-block mr-2"}>Diese Webseite benutzt Cookies. Wenn du die Webseite
                                weiter nutzt, gehen wir von deinem Einverständnis aus.</p>
                            <ShButton onClick={acceptCookies} className={"d-inline-block"} variant={"outline"}
                                      size={"small"}>OK</ShButton>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        }

    </>;

};

export default Footer;
